import { SearchArticleRef } from 'helpCenter/types'
import { authorizedGet } from '.'
export type GetSearchProps = {
  query: string
  collectionId?: string
  siteId?: string
}
export type SearchResults = SearchArticleRef[]

export type CollectionSearchParams = {
  query: string
  collectionId: string
}

export async function search({
  query,
  collectionId,
}: GetSearchProps): Promise<SearchResults> {
  try {
    const params = { query, collectionId } as CollectionSearchParams

    const response = await authorizedGet({
      endpoint: `search`,
      params,
    })
    const { items } = await response.json() // { items, count, pages, page }
    return items as SearchArticleRef[]
  } catch (e) {
    throw e
  }
}
